// Module
var code = "<title>Customily Options</title> <div class=\"options-page\" ng-controller=\"OptionsCtrl\" ng-cloak> <iframe ng-src=\"{{ iFrameUrl }}\"></iframe> </div> ";
// Exports
module.exports = code;